import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: "24px 28px",
    backgroundColor: "#FFFFFF",
    [theme.breakpoints?.down("sm")]: {
      padding: "16px 18px",
    },
  },
  content: {
    width: "100%",
  },
  form__content: {
    marginBottom: 16,
    "& .MuiGrid-item": {
      padding: "6px 8px !important",
    },
  },
  noticeCard: {
    backgroundColor: "#FFFBEB",
    border: "1px solid #FDE68A",
    borderRadius: 12,
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 20,
    marginTop: 8,
  },
  noticeText: {
    fontSize: "0.84rem",
    color: "#92400E",
    fontWeight: 500,
    "& strong": {
      color: "#B45309",
      fontWeight: 700,
    },
  },
  actionGroup: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 12,
    marginTop: 8,
  },
  btnCancel: {
    borderRadius: 10,
    padding: "9px 24px",
    fontSize: "0.875rem",
    fontWeight: 700,
    textTransform: "none",
    color: "#475569",
    borderColor: "#CBD5E1",
    "&:hover": {
      backgroundColor: "#F8FAFC",
      borderColor: "#94A3B8",
    },
  },
  btnSubmit: {
    background: "linear-gradient(135deg, #0F172A 0%, #312E81 100%)",
    borderRadius: 10,
    padding: "9px 28px",
    fontSize: "0.875rem",
    fontWeight: 700,
    textTransform: "none",
    color: "#FFFFFF !important",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.2)",
    transition: "all 0.2s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #1E1B4B 0%, #4338CA 100%)",
      boxShadow: "0 6px 20px rgba(15, 23, 42, 0.3)",
    },
  },
}));

export default useStyles;
